export default {
  getAppointments: `${process.env.REACT_APP_GOVERNANCE_URL}/apontamento/all`,
  updateAppointmentsFromAhgora: `${process.env.REACT_APP_GOVERNANCE_URL}/update_from_ahgora`,
  projectsList: `${process.env.REACT_APP_GOVERNANCE_URL}/projeto/active`,
  postAppointments: `${process.env.REACT_APP_GOVERNANCE_URL}/apontamento/insert`,
  deleteAppointment: `${process.env.REACT_APP_GOVERNANCE_URL}/apontamento/delete`,
  insertOvertime: `${process.env.REACT_APP_GOVERNANCE_URL}/hora_extra/insert`,
  justificationsList: `${process.env.REACT_APP_GOVERNANCE_URL}/hora_extra/justificativas`,
  initializeUserData: `${process.env.REACT_APP_EMPLOYEES_URL}/usuario`,
  approveHours: `${process.env.REACT_APP_GOVERNANCE_URL}/apontamento/aprovacao`,
  postApproval: `${process.env.REACT_APP_GOVERNANCE_URL}/apontamento/aprovacao/update`,
  getProjects: `${process.env.REACT_APP_GOVERNANCE_URL}/projeto`,
  insertProject: `${process.env.REACT_APP_GOVERNANCE_URL}/projeto/insert`,
  updateProject: `${process.env.REACT_APP_GOVERNANCE_URL}/projeto/update`,
  deleteProject: `${process.env.REACT_APP_GOVERNANCE_URL}/projeto/delete`,
  getAllocatedEmployees: `${process.env.REACT_APP_GOVERNANCE_URL}/alocacao/alocacao_projeto`,
  getAllEmployeeAllocations: `${process.env.REACT_APP_GOVERNANCE_URL}/alocacao/id_funcionario`,
  getAllocation: `${process.env.REACT_APP_GOVERNANCE_URL}/alocacao`,
  insertAlocation: `${process.env.REACT_APP_GOVERNANCE_URL}/alocacao/insert`,
  updateAllocation: `${process.env.REACT_APP_GOVERNANCE_URL}/alocacao/update`,
  deleteAllocation: `${process.env.REACT_APP_GOVERNANCE_URL}/alocacao/delete`,
  getSales: `${process.env.REACT_APP_RETAIL_URL}/venda/all`,
  insertSale: `${process.env.REACT_APP_RETAIL_URL}/venda/insert`,
  updateSale: `${process.env.REACT_APP_RETAIL_URL}/venda/update`,
  deleteSale: `${process.env.REACT_APP_RETAIL_URL}/venda/delete`,
  getClients: `${process.env.REACT_APP_RETAIL_URL}/cliente/all`,
  insertClient: `${process.env.REACT_APP_RETAIL_URL}/cliente/insert`,
  updateClient: `${process.env.REACT_APP_RETAIL_URL}/cliente/update`,
  deleteClient: `${process.env.REACT_APP_RETAIL_URL}/cliente/delete`,
  getEmployees: `${process.env.REACT_APP_EMPLOYEES_URL}/funcionario/all`,
  getCompanys: `${process.env.REACT_APP_EMPLOYEES_URL}/empresas/all`,
  getEmployeesToSelect: `${process.env.REACT_APP_EMPLOYEES_URL}/funcionario/funcao_nivel`,
  insertEmployee: `${process.env.REACT_APP_EMPLOYEES_URL}/funcionario/cadastro`,
  updateEmployee: `${process.env.REACT_APP_GOVERNANCE_URL}/funcionario/delete`,
  deleteEmployee: `${process.env.REACT_APP_GOVERNANCE_URL}/funcionario/delete`,
  insertAddress: `${process.env.REACT_APP_EMPLOYEES_URL}/endereco/cadastro`,
  deleteAdress: `${process.env.REACT_APP_GOVERNANCE_URL}/endereco/delete`,
  statusCatProjeto: `${process.env.REACT_APP_GOVERNANCE_URL}/status/categoria`,
  salesFunctionTypes: `${process.env.REACT_APP_RETAIL_URL}/tipo/venda/all`,
  alocatedProjectList: `${process.env.REACT_APP_GOVERNANCE_URL}/projeto/projetos_alocados`,
  getEmployeeLevel: `${process.env.REACT_APP_EMPLOYEES_URL}/nivel/all`,
  getEmployeeFunction: `${process.env.REACT_APP_EMPLOYEES_URL}/funcao/all`,
  getEmployeeResponsibility: `${process.env.REACT_APP_EMPLOYEES_URL}/cargo/all`,
  insertEmployeeContacts: `${process.env.REACT_APP_EMPLOYEES_URL}/contato/cadastro`,
  insertEmployeeDocuments: `${process.env.REACT_APP_EMPLOYEES_URL}/documento/cadastro`,
  validateEmployeeBeforeAlocate: `${process.env.REACT_APP_GOVERNANCE_URL}/alocacao/validacao`,
  getCoustCenterOptions: `${process.env.REACT_APP_EMPLOYEES_URL}/centro_de_custo/all`,
  getRefundsInfoToEmployee: `${process.env.REACT_APP_CLIENTS_URL}/reembolso/funcionario`,
  getRefundsInfoToProjectManager: `${process.env.REACT_APP_CLIENTS_URL}/reembolso/gerente_projeto`,
  getRefundsInfoToFinancial: `${process.env.REACT_APP_CLIENTS_URL}/reembolso/financeiro`,
  refundsCategoryTypes: `${process.env.REACT_APP_CLIENTS_URL}/reembolso/all_tipo`,
  RequestRefund: `${process.env.REACT_APP_CLIENTS_URL}/reembolso/inserir`,
  deleteRequestedRefund: `${process.env.REACT_APP_CLIENTS_URL}/reembolso/delete`,
  approveRefund: `${process.env.REACT_APP_CLIENTS_URL}/reembolso/aprovar`,
  refundFiles: `${process.env.REACT_APP_CLIENTS_URL}/reembolso/images/download`,
  deleteRefundFile: `${process.env.REACT_APP_CLIENTS_URL}/reembolso/images/delete`,
  deleteRefundItem: `${process.env.REACT_APP_CLIENTS_URL}/reembolso/item/delete`,
  getApproveStatus: `${process.env.REACT_APP_CLIENTS_URL}/aprovacao/all`,
  getPDIHistory: `${process.env.REACT_APP_PDI_URL}/home/historico_avaliacao`,
  getAllPDISolicitations: `${process.env.REACT_APP_PDI_URL}/home/avaliacao_mediacao`,
  changePDISolicitation: `${process.env.REACT_APP_PDI_URL}/home/atualizar_solicitacao`,
  getEvaluation: `${process.env.REACT_APP_PDI_URL}/pdi_questoes/all`,
  saveEvaluation: `${process.env.REACT_APP_PDI_URL}/pdi_respostas/save`,
  uploadOthersCertificates: `${process.env.REACT_APP_PDI_URL}/upload/outros_certificados`,
  uploadCertificates: `${process.env.REACT_APP_PDI_URL}/submeter_avaliacao`,
  getJustifications: `${process.env.REACT_APP_PDI_URL}/obter/justificativa`,
  getPDITeam: `${process.env.REACT_APP_PDI_URL}/equipe/obter_equipe`,
  releaseEvaluation: `${process.env.REACT_APP_PDI_URL}/equipe/liberar_avaliacao`,
  requestMemberSolicitation: `${process.env.REACT_APP_PDI_URL}/solicitacao/inserir`,
  allPDIResults: `${process.env.REACT_APP_PDI_URL}/pdi-resultados-all`,
  publishResult: `${process.env.REACT_APP_PDI_URL}/pdi/resultados-all/publish`,
  getPDICertificates: `${process.env.REACT_APP_PDI_URL}/download/base64`,
  getAreas: `${process.env.REACT_APP_PDI_URL}/obter/area`,
  insertArea: `${process.env.REACT_APP_PDI_URL}/salvar/area`,
  updateArea: `${process.env.REACT_APP_PDI_URL}/editar/area`,
  deleteArea: `${process.env.REACT_APP_PDI_URL}/excluir/area`,
  getBlocks: `${process.env.REACT_APP_PDI_URL}/obter/bloco`,
  insertBlock: `${process.env.REACT_APP_PDI_URL}/salvar/bloco`,
  updateBlock: `${process.env.REACT_APP_PDI_URL}/editar/bloco`,
  deleteBlock: `${process.env.REACT_APP_PDI_URL}/excluir/bloco`,
  getQuestions: `${process.env.REACT_APP_PDI_URL}/obter/questoes`,
  insertQuestion: `${process.env.REACT_APP_PDI_URL}/salvar/questoes`,
  updateQuestion: `${process.env.REACT_APP_PDI_URL}/editar/questoes`,
  deleteQuestion: `${process.env.REACT_APP_PDI_URL}/excluir/questoes`,
  getQuestionTypes: `${process.env.REACT_APP_PDI_URL}/obter/tipo_questao`,
  getTeam: `${process.env.REACT_APP_PDI_URL}/obter/equipe`,
  getConfigsForm: `${process.env.REACT_APP_PDI_URL}/obter/parametros_visao`,
  saveConfigsForm: `${process.env.REACT_APP_PDI_URL}/atualizar/parametros_visao`,
  getJustificationScope: `${process.env.REACT_APP_GOVERNANCE_URL}/justificativa_tipo_escopo`,
  postAdminAppointment: `${process.env.REACT_APP_GOVERNANCE_URL}/apontamento/insert/adm`,
  getAppointmentPendencies: `${process.env.REACT_APP_GOVERNANCE_URL}/apontamento/pendente`,
  getPrivilegesData: `${process.env.REACT_APP_EMPLOYEES_URL}/funcao/gerencia_privilegio`,
  updatePrivileges: `${process.env.REACT_APP_EMPLOYEES_URL}/funcao/edit_gerencia_privilegio`,
  getListboxesValues: `${process.env.REACT_APP_EMPLOYEES_URL}/select/lista`,
  deleteListboxesValues: `${process.env.REACT_APP_EMPLOYEES_URL}/delete/lista`,
  editListboxesValues: `${process.env.REACT_APP_EMPLOYEES_URL}/cadastro/lista`,
  getProjectStatusAndCategoryListboxesValues: `${process.env.REACT_APP_GOVERNANCE_URL}/projeto/show_projeto_endpoint`,
  deleteProjectStatusAndCategoryListboxesValues: `${process.env.REACT_APP_GOVERNANCE_URL}/projeto/delete_projeto_endpoint`,
  editProjectStatusAndCategoryListboxesValues: `${process.env.REACT_APP_GOVERNANCE_URL}/projeto/insert_or_update_endpoint`,
};
